module.exports = __webpack_public_path__ + "img/imago-usach-blanco.0323e250.svg";